import { ChangeDetectionStrategy, Component, input, computed } from '@angular/core';
import { Incident, Severity } from '../../models/incident';

@Component({
    selector: 'app-header',
    templateUrl: './header.html',
    styleUrl: './header.css',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
    incidents = input<Incident[]>([]);

    severityClass = computed(() => {
        const incidents = this.incidents();

        if (incidents.length > 0) {
            const severity = this.getHighestSeverity(incidents);
            return severity ? `alert-${severity}` : '';
        }
        return '';
    });

    private getHighestSeverity(incidents: Incident[]): Severity | undefined {
        if (incidents.some((i) => i.severity === Severity.P1)) {
            return Severity.P1;
        }
        if (incidents.some((i) => i.severity === Severity.P2)) {
            return Severity.P2;
        }
        return undefined;
    }
}
